import { render, staticRenderFns } from "./CommentCardEdit.vue?vue&type=template&id=4046c618&scoped=true&"
import script from "./CommentCardEdit.vue?vue&type=script&lang=js&"
export * from "./CommentCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommentCardEdit.vue?vue&type=style&index=0&id=4046c618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046c618",
  null
  
)

export default component.exports